module.exports = __webpack_public_path__ + "static/media/logo.d672e27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/logo.png
// module id = 92
// module chunks = 0